// actions.js
import * as actionTypes from "./actionsTypes";

export const setValueModeleInvestissement = (value) => ({
  type: actionTypes.SET_VALUE_ModeleInvestissement,
  payload: value,
});

export const setTypeModeleInvestissement = (type) => ({
  type: actionTypes.SET_TYPE_ModeleInvestissement,
  payload: type,
});
export const setActifModeleInvestissement = (actif) => ({
  type: actionTypes.SET_ACTIF_ModeleInvestissement,
  payload: actif,
});

export const setCurrentPageModeleInvestissement = (page) => ({
  type: actionTypes.SET_CURRENT_PAGE_ModeleInvestissement,
  payload: page,
});

export const setOrderModeleInvestissement = (order) => ({
  type: actionTypes.SET_ORDER_ModeleInvestissement,
  payload: order,
});

export const setSortFieldModeleInvestissement = (field) => ({
  type: actionTypes.SET_SORT_FIELD_ModeleInvestissement,
  payload: field,
});
export const setCategorieModeleInvestissement = (categorie) => ({
  type: actionTypes.SET_CATEGORIE_ModeleInvestissement,
  payload: categorie,
});
